
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isEqual';
import 'just-kebab-case';
import './labels-mixin.js';
import 'focus-visible/dist/focus-visible.js';
import './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import './pendo-icon.js';
import 'vue';
import 'lodash/get';
import './pendo-loading-mixin.js';
import './pendo-loading-indicator.js';
import './pendo-button.js';
import './collapse-transition-mixin.js';
import 'color';
import 'color-string';
import './color-picker-helper-mixin.js';
import './pendo-tag.js';
import 'v-tooltip';
import './tooltip-mixin.js';
import PendoTooltip from './pendo-tooltip.js';
import PendoCard from './pendo-card.js';
import './pendo-divider.js';
import 'lodash/isNumber';
import './table-auto-height-mixin.js';
import 'popper.js';
import 'uuid';
import 'vue-resize';
import 'lodash/clamp';
import './picker-popover-mixin.js';
import PendoDrawer from './pendo-drawer.js';
import 'lodash/debounce';
import './emitter-mixin.js';
import 'element-ui/lib/dialog';
import 'resize-observer-polyfill';
import './pendo-modal.js';
import 'lodash/isFunction';
import './multiselect-helper-mixin.js';
import './pendo-multiselect-props.js';
import './pendo-multiselect-core.js';
import './pendo-multiselect-input.js';
import './pendo-multiselect-option.js';
import 'compute-scroll-into-view';
import './pendo-multiselect-options.js';
import './pendo-multiselect-trigger.js';
import './pendo-multiselect-value.js';
import PendoMultiselect from './pendo-multiselect.js';
import './pendo-popover.js';
import 'vue-observe-visibility';
import PendoIconOption from './pendo-icon-option.js';
import './pendo-chooser-grid.js';
import PendoFilterBar from './pendo-filter-bar.js';
import './pendo-layout-preview.js';
import PendoLayoutGrid from './pendo-layout-grid.js';
import { D as Defer } from './defer-mixin.js';
import PendoAffix from './pendo-affix.js';

var script = {
  name: 'PendoLayoutChooser',
  components: {
    PendoCard,
    PendoDrawer,
    PendoFilterBar,
    PendoIconOption,
    PendoLayoutGrid,
    PendoMultiselect
  },
  directives: {
    PendoAffix,
    PendoTooltip
  },
  mixins: [Defer()],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    layouts: {
      type: Array,
      default: null
    },
    defaultLayouts: {
      type: Array,
      default: null
    },
    defaultLayoutsTitle: {
      type: String,
      default: 'Default'
    },
    customLayouts: {
      type: Array,
      default: null
    },
    customLayoutsTitle: {
      type: String,
      default: 'Saved'
    },
    organizationLayouts: {
      type: Array,
      default: null
    },
    organizationLayoutsTitle: {
      type: String,
      default: 'Organization'
    },
    title: {
      type: String,
      default: 'Create Guide'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    allowActions: {
      type: Object,
      default: () => ({})
    },
    placement: {
      type: String,
      default: 'bottom'
    },
    zIndex: {
      type: Number,
      default: 502
    },
    apps: {
      type: Array,
      default: null
    },
    selectedApp: {
      type: Object,
      default: null
    },
    themes: {
      type: Array,
      default: null
    },
    selectedTheme: {
      type: Object,
      default: null
    },
    filters: {
      type: [Object, Array],
      default: () => [{
        prop: ['title'],
        value: ''
      }]
    },
    appendTo: {
      type: [String, Element, Boolean],
      default: 'body'
    }
  },

  data() {
    return {
      observer: undefined,
      isDrawerOpening: false
    };
  },

  computed: {
    isVisible: {
      get() {
        if (this.$options.propsData.visible == null) {
          return true;
        }

        return this.visible;
      },

      set(val) {
        this.$emit('update:visible', val);

        if (!val) {
          this.$emit('close');
          this.$emit('onClose');
        }
      }

    },

    appThemeCardTitle() {
      const title = [];

      if (this.$slots.appChooser || this.apps) {
        title.push('Application');
      }

      if (this.$slots.themeChooser || this.themes) {
        title.push('Theme');
      }

      return title.join(' & ');
    }

  },
  methods: {
    showAppThemeCard() {
      return this.apps || this.themes || this.$slots.appChooser || this.$scopedSlots.appChooser || this.$slots.themeChooser || this.$scopedSlots.themeChooser;
    },

    handleDrawerOpen() {
      this.isDrawerOpening = true;
    },

    handleDrawerOpened() {
      this.isDrawerOpening = false;
    },

    selectApp(app) {
      this.$emit('select-app', app);
    },

    selectTheme(theme) {
      this.$emit('select-theme', theme);
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('pendo-drawer', {
    attrs: {
      "visible": _vm.isVisible,
      "title": _vm.title,
      "placement": _vm.placement,
      "size": "fullscreen",
      "append-to": _vm.appendTo,
      "z-index": _vm.zIndex
    },
    on: {
      "update:visible": function ($event) {
        _vm.isVisible = $event;
      },
      "open": _vm.handleDrawerOpen,
      "opened": _vm.handleDrawerOpened
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function () {
        return [_vm.layouts && _vm.isVisible && !_vm.isDrawerOpening ? _c('div', {
          staticClass: "pendo-layout-chooser"
        }, [_vm._t("filters"), _vm._v(" "), _vm._t("beforeLayouts", [_vm.showAppThemeCard() ? _c('pendo-card', {
          staticClass: "pendo-layout-chooser__app-theme-card",
          attrs: {
            "title": _vm.appThemeCardTitle,
            "body-min-height": "118px"
          }
        }, [_vm._t("appChooser", [_vm.apps ? _c('div', {
          staticClass: "pendo-layout-chooser__app-selector"
        }, [_c('pendo-multiselect', {
          attrs: {
            "value": _vm.selectedApp,
            "preselect-first": "",
            "full-width": "",
            "label-key": "name",
            "allow-empty": false,
            "labels": {
              top: 'Application'
            },
            "options": _vm.apps,
            "disabled": _vm.loading || _vm.apps.length === 1,
            "loading": _vm.loading
          },
          on: {
            "select": _vm.selectApp
          },
          scopedSlots: _vm._u([{
            key: "selectedLabel",
            fn: function (ref) {
              var option = ref.option;
              return _c('pendo-icon-option', {
                attrs: {
                  "option": option
                }
              });
            }
          }, {
            key: "option",
            fn: function (ref) {
              var option = ref.option;
              return _c('pendo-icon-option', {
                attrs: {
                  "option": option
                }
              });
            }
          }], null, false, 794695301)
        })], 1) : _vm._e()]), _vm._v(" "), _vm._t("themeChooser", [_vm.themes ? _c('div', {
          staticClass: "pendo-layout-chooser__theme-selector"
        }, [_c('pendo-multiselect', {
          attrs: {
            "value": _vm.selectedTheme,
            "label-key": "name",
            "full-width": "",
            "preselect-first": "",
            "loading": _vm.loading,
            "allow-empty": false,
            "disabled": _vm.loading || _vm.themes.length === 1,
            "labels": {
              top: 'Theme'
            },
            "options": _vm.themes
          },
          on: {
            "select": _vm.selectTheme
          }
        })], 1) : _vm._e()])], 2) : _vm._e()]), _vm._v(" "), _vm._t("layouts", [_vm.defer(2) ? _c('pendo-layout-grid', _vm._g(_vm._b({
          attrs: {
            "title": "Layout"
          }
        }, 'pendo-layout-grid', _vm.$props, false), _vm.$listeners)) : _vm._e()]), _vm._v(" "), _vm._t("afterLayouts")], 2) : _vm._e()];
      },
      proxy: true
    }], null, true)
  }, [_vm._v(" "), !_vm.layouts && _vm.isVisible && !_vm.isDrawerOpening ? _c('div', {
    staticClass: "pendo-layout-chooser pendo-layout-chooser--v2"
  }, [_vm.apps ? _c('pendo-filter-bar', {
    directives: [{
      name: "pendo-affix",
      rawName: "v-pendo-affix",
      value: {
        root: '.pendo-layout-chooser',
        rootMargin: 24,
        fixedStyles: {
          left: 0,
          right: 0,
          padding: '0 24px',
          zIndex: 1
        }
      },
      expression: "{\n                root: '.pendo-layout-chooser',\n                rootMargin: 24,\n                fixedStyles: {\n                    left: 0,\n                    right: 0,\n                    padding: '0 24px',\n                    zIndex: 1\n                }\n            }"
    }]
  }, [_c('div', {
    staticClass: "pendo-layout-chooser__app-selector"
  }, [_c('pendo-multiselect', {
    attrs: {
      "value": _vm.selectedApp,
      "preselect-first": "",
      "label-key": "name",
      "allow-empty": false,
      "labels": {
        left: 'Application'
      },
      "options": _vm.apps,
      "disabled": _vm.loading || _vm.apps.length === 1,
      "loading": _vm.loading
    },
    on: {
      "select": _vm.selectApp
    },
    scopedSlots: _vm._u([{
      key: "selectedLabel",
      fn: function (ref) {
        var option = ref.option;
        return _c('pendo-icon-option', {
          attrs: {
            "option": option
          }
        });
      }
    }, {
      key: "option",
      fn: function (ref) {
        var option = ref.option;
        return _c('pendo-icon-option', {
          attrs: {
            "option": option
          }
        });
      }
    }], null, false, 794695301)
  })], 1)]) : _vm._e(), _vm._v(" "), _vm._t("empty"), _vm._v(" "), _vm.defer(2) && _vm.organizationLayouts && _vm.organizationLayouts.length ? _c('pendo-layout-grid', _vm._g(_vm._b({
    attrs: {
      "collapsible": "",
      "title": _vm.organizationLayoutsTitle,
      "layouts": _vm.organizationLayouts
    }
  }, 'pendo-layout-grid', _vm.$props, false), _vm.$listeners), [_c('template', {
    slot: "beforeLayouts"
  }, [_vm._t("beforeOrganizationLayouts")], 2)], 2) : _vm._e(), _vm._v(" "), _vm.defer(3) && _vm.customLayouts && _vm.customLayouts.length ? _c('pendo-layout-grid', _vm._g(_vm._b({
    attrs: {
      "collapsible": "",
      "title": _vm.customLayoutsTitle,
      "layouts": _vm.customLayouts
    }
  }, 'pendo-layout-grid', _vm.$props, false), _vm.$listeners), [_c('template', {
    slot: "beforeLayouts"
  }, [_vm._t("beforeCustomLayouts")], 2)], 2) : _vm._e(), _vm._v(" "), _vm.defer(4) && _vm.defaultLayouts && _vm.defaultLayouts.length ? _c('pendo-layout-grid', _vm._g(_vm._b({
    attrs: {
      "collapsible": "",
      "title": _vm.defaultLayoutsTitle,
      "layouts": _vm.defaultLayouts
    }
  }, 'pendo-layout-grid', _vm.$props, false), _vm.$listeners), [_c('template', {
    slot: "beforeLayouts"
  }, [_vm.themes ? _c('div', {
    staticClass: "pendo-layout-chooser__theme-selector"
  }, [_c('pendo-multiselect', {
    attrs: {
      "value": _vm.selectedTheme,
      "label-key": "name",
      "min-trigger-width": 162,
      "preselect-first": "",
      "loading": _vm.loading,
      "allow-empty": false,
      "disabled": _vm.loading || _vm.themes.length === 1,
      "labels": {
        left: 'Theme'
      },
      "options": _vm.themes
    },
    on: {
      "select": _vm.selectTheme
    }
  })], 1) : _vm._e()])], 2) : _vm._e()], 2) : _vm._e()]);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-layout-chooser.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var pendoLayoutChooser = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default pendoLayoutChooser;
